import script from "./Education.vue?vue&type=script&setup=true&lang=js"
export * from "./Education.vue?vue&type=script&setup=true&lang=js"

import "./Education.vue?vue&type=style&index=0&id=1f0aa4fd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f0aa4fd"]])

export default __exports__